<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <h5 role="alert" class="modal-title alert alert-danger" id="commandAlertLabel">{{ confirm.title
                            }}</h5>
                        <button type="button" class="close" @click="$emit('close')" data-dismiss="modal"
                                aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{confirm.msg}}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
                        <button type="button" class="btn btn-danger" @click="deleteAction($event)">
                            YES!!!
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
  import ConnectionService from '../../app-model/model'

  const connectionService = new ConnectionService()
  export default {
    props: {
      dataToPassToModal: Object,
      confirm: Object,
      dataObject: Array
    },
    methods: {
      deleteAction: function (event) {
        this.dataToPassToModal.showModal = false
        this.$store.dispatch('apiResult', {
          method: 'delete',
          path: this.dataToPassToModal.router + this.dataToPassToModal.id,
          path_template: this.dataToPassToModal.pathTemplate
        }).then(response => {
          switch (response.status) {
            case 200:
              this.dataObject.splice(this.dataToPassToModal.index, 1)
              break
            case 422:

              break
          }
        })

      },
    }
  }
</script>

<style>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 500px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        text-align:left;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>